import api from '@/api'

const { $core } = api;

export const { $processings } = $core;  